import { motion } from "motion/react"
import { Link } from "@tanstack/react-router"
import React, { type ReactNode } from "react"

import { BackgroundBeamsWithCollision } from "./BackgroundBeamsWithCollision"
import { Button } from "./Button"

/** NotFound with page-specific copy and action; the defaults are NotFound's. */
export const NotFoundLayout = ({
  title = "404 - Page not found",
  description = "Oops! The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.",
  action = (
    <Link to="/">
      <Button asChild>Go back home</Button>
    </Link>
  ),
}: {
  title?: string
  description?: string
  action?: ReactNode
}) => {
  return (
    <BackgroundBeamsWithCollision className="relative flex flex-col items-center justify-center">
      <motion.div
        className="z-10 flex flex-col items-center gap-4"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <motion.h1
          className="text-6xl font-bold text-fg-base"
          initial={{ scale: 0.9 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.5 }}
        >
          {title}
        </motion.h1>

        <motion.p
          className="text-lg text-fg-subtle max-w-md text-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.6 }}
        >
          {description}
        </motion.p>

        {action}
      </motion.div>
    </BackgroundBeamsWithCollision>
  )
}

const NotFound = () => <NotFoundLayout />

export default NotFound
